import React, { useState } from "react";
import { Container, Typography, Button, TextField, Autocomplete, Box } from "@mui/material";
import { motion } from "framer-motion";

const pageVariants = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -20 },
};

const LocationDropdown = (props) => {
  const question = props.questionObject.question;
  const unAvailStates = [
    "American Samoa",
    "Federated States of Micronesia",
    "Guam",
    "Marshall Islands",
    "Northern Mariana Islands",
    "Virgin Island",
    "Puerto Rico",
    "Palau",
  ];
  const availStates = props.questionObject.responseChoices.filter((val) => {
    return !unAvailStates.includes(val);
  });
  const answer = availStates;
  const [buttonDisable, setButtonDisable] = useState(true);

  const onClickHandler = (locationState) => {
    if (isValidLocationState(locationState)) {
      props.buttonClick(locationState);
    }
  };

  const isValidLocationState = (locationState) => {
    return answer.includes(locationState);
  };

  return (
    <motion.div
      key="location-dropdown"
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: 0.4, ease: [0.25, 0.1, 0.25, 1] }}
    >
      <Container
        maxWidth="sm"
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          py: { xs: 2, sm: 4 },
        }}
      >
        <Typography
          variant="h5"
          sx={{
            fontWeight: 600,
            color: "text.primary",
            lineHeight: 1.5,
            mb: { xs: 3, sm: 4 },
            fontSize: { xs: "1.15rem", sm: "1.35rem", md: "1.5rem" },
            maxWidth: 600,
            letterSpacing: "-0.01em",
          }}
        >
          {question}
        </Typography>

        <Box
          sx={{
            width: "100%",
            maxWidth: 400,
            mb: 3,
          }}
        >
          <Autocomplete
            disablePortal
            options={answer}
            onChange={(event, newValue) => {
              props.locationHandler(newValue);
              if (isValidLocationState(newValue)) {
                setButtonDisable(false);
              } else {
                setButtonDisable(true);
              }
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select your state"
                variant="outlined"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 3,
                    backgroundColor: "rgba(255, 255, 255, 0.8)",
                    backdropFilter: "blur(8px)",
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#CE93D8",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#7B1FA2",
                      borderWidth: 2,
                    },
                  },
                  "& .MuiInputLabel-root.Mui-focused": {
                    color: "#7B1FA2",
                  },
                }}
              />
            )}
            sx={{
              "& .MuiAutocomplete-paper": {
                borderRadius: 3,
                boxShadow: "0 8px 32px rgba(123, 31, 162, 0.15)",
              },
            }}
          />
        </Box>

        <Button
          variant="contained"
          size="large"
          onClick={() => onClickHandler(props.locationState)}
          disabled={buttonDisable}
          sx={{
            py: 1.5,
            px: 5,
            fontSize: "1rem",
            borderRadius: 3,
            background:
              "linear-gradient(135deg, #7B1FA2 0%, #9C27B0 50%, #E040FB 100%)",
            color: "#FFFFFF",
            fontWeight: 600,
            textTransform: "none",
            boxShadow: "0 4px 16px rgba(123, 31, 162, 0.25)",
            "&:hover": {
              background:
                "linear-gradient(135deg, #6A1B9A 0%, #8E24AA 50%, #D500F9 100%)",
              transform: "translateY(-2px)",
              boxShadow: "0 6px 24px rgba(123, 31, 162, 0.35)",
            },
            "&:active": {
              transform: "translateY(0)",
            },
            "&.Mui-disabled": {
              background: "rgba(123, 31, 162, 0.12)",
              color: "rgba(26, 26, 46, 0.4)",
              boxShadow: "none",
            },
            transition: "all 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
          }}
        >
          Continue
        </Button>
      </Container>
    </motion.div>
  );
};

export default LocationDropdown;
